import React from 'react'

export default () => {}

export const RftContext = React.createContext()

export function RftContextProvider({ value, children }) {
  return <RftContext.Provider value={value}>{children}</RftContext.Provider>
}
